var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleAccent600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.6198V17.9998C32.9982 21.2344 31.9508 24.3818 30.014 26.9725C28.0773 29.5633 25.3549 31.4585 22.253 32.3756C19.1511 33.2928 15.8359 33.1826 12.8017 32.0617C9.76752 30.9407 7.17698 28.8689 5.41644 26.1554C3.6559 23.4418 2.81969 20.2319 3.03252 17.0043C3.24534 13.7766 4.49581 10.7043 6.59742 8.24541C8.69903 5.78653 11.5392 4.07287 14.6943 3.36002C17.8494 2.64716 21.1504 2.9733 24.105 4.2898M33 5.9998L18 21.0148L13.5 16.5148",
    stroke: "#648CE6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleAccent600);
export default __webpack_public_path__ + "static/media/check-circle-accent600.fe0be7bd1e909059f5de13edbc211185.svg";
export { ForwardRef as ReactComponent };